import React from "react";
import useCoreAgoraCheck from "../../../../general/customHooks/coreAgoraCheck";
import { ExclamationTriangle } from "react-bootstrap-icons";
import VideoPlayerThum from "../../../../general/components/VideoUser/VideoPlayerThum";
import VideoControl from "../molekuls/VideoControl";
import LottieLoadingLine from "../../../../general/components/lottie/lineLoading/LottieLoadingLine";
import LottieLoading from "../../../../general/components/lottie/loading/LottieLoading";
import useDataSession from "../../../SessionMethodVideoModul/customeHooks/useDataSession";
import {
  unixTime,
  unixToDayDDMMMMYYYY,
  unixToFullDateTime,
} from "../../../../general/functions/datetimeFunction";

const dataShow = [
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
  },
];
const LOREMIPSUM =
  "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?";

export default function AssesseeView() {
  const {
    isSelfTracksReady,
    selfTracks,
    isMuteTrackSelf,
    setMuteSelfTracks,
    error,
  } = useCoreAgoraCheck();
  const { selfUid, session, listUser, dataSession } = useDataSession();
  console.log("useDataSession", selfUid, session, listUser, dataSession);
  console.log("error", error);
  //   console.log("error", error?.name);
  //   console.log("error", error?.code == "PERMISSION_DENIED");

  return (
    <div className="flex justify-center items-center h-screen bg-gray-50 ">
      <div className="absolute top-0 w-full left-0">
        <LottieLoadingLine />
      </div>

      <div className="flex flex-col  w-full items-center justify-center p-2 gap-4 ">
        <div className="flex flex-col md:flex-row max-w-4xl w-full  shadow-sm border p-2 rounded-lg bg-white relative">
          {/*  */}
          {isSelfTracksReady && (
            <>
              <div className="w-full aspect-video  relative">
                <VideoPlayerThum
                  videoTrack={selfTracks[1]}
                  isVideoMute={!isMuteTrackSelf?.video}
                  isMicMute={!isMuteTrackSelf?.audio}
                  title={"Name User"}
                  uid={"userSelf?.uId"}
                  isSpeak={false}
                />
                <div className="absolute bottom-2 w-full flex justify-center">
                  <VideoControl
                    setMute={(v) => {
                      setMuteSelfTracks(v?.type, v?.status);
                    }}
                    tracksState={isMuteTrackSelf}
                  />
                </div>
              </div>
            </>
          )}
          {isSelfTracksReady == false && error == null && (
            <div className="w-full aspect-video max-w-md relative flex flex-col items-center justify-center gap-2 bg-gray-800 rounded-md">
              <label className="font-medium text-sm text-white">
                Compatibility check...
              </label>
            </div>
          )}
          {error != null && (
            <div className="w-full aspect-video max-w-md relative flex flex-col items-center justify-center gap-2 bg-gray-800 rounded-md">
              <ExclamationTriangle size={32} className="text-white" />
              <label className="font-medium text-sm text-white">{error}</label>
            </div>
          )}

          <div className="max-w-md w-full p-4 flex flex-col items-start relative ">
            <p className=" w-full text-left text-sm font-bold text-gray-600">
              Waiting Room | {dataSession?.sessionInfo?.methodName}
            </p>
            <h1 className="text-3xl text-primary-500 font-bold leading-tight ">
              {dataSession?.sessionInfo?.sessionTitle}
            </h1>
            <p className="text-sm text-secondary-500 leading-5">Scheduled:</p>
            {dataSession?.sessionInfo?.startTime != undefined && (
              <p className="font-medium text-left text-sm text-secondary-500 leading-5">
                {" " + unixToDayDDMMMMYYYY(dataSession?.sessionInfo?.startTime)}
                <br />
                {" " + unixTime(dataSession?.sessionInfo?.startTime)}
              </p>
            )}
            <p className="text-sm text-secondary-500 leading-5">
              Join As Assessee
            </p>
            {/* <div className="absolute right-1 bottom-1 w-16">
              <LottieLoading />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
